import styled from 'styled-components';

export const StyledHeader = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: end;
   position: relative;
`;
